import { post } from '../axios'

// 用户反馈提交 todo
export function v1_portal_uer_feedback_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v2/userExperience/submit`,
    map,
    option
  ).then(response => response)
}
